import { useState } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import ClientInfoTable from "./ClientInfoTable";
import SearchForm from "./SearchForm";
import UnMapModal from "./UnMapModal";
import UpdationConfirmationModal from "./UpdationConfirmationModal";
import UpdationModal from "./UpdationModal";
import { toast } from "react-toastify";
import {
  useClientDetails,
  useTelecallerIDUpdation,
  useUnmapTelecallerUserID,
} from "./useTelecallerIDUpdation";

const TelecallerIDUpdation = () => {
  const [showUpdationModal, setShowUpdationModal] = useState(false);
  const [showUpdationConfirmationModal, setShowUpdationConfirmationModal] =
    useState(false);
  const [showUnMApModal, setShowUnMapModal] = useState(false);
  const [dataToUpdate, setDataToUpdate] = useState({
    refNo: "",
    userId: "",
  });

  const {
    isLoading: searchResultsLoading,
    fetchClientDataByRefNumber,
    data,
    error,
  } = useClientDetails();
  const { isLoading: updating, updateTelecallerID } = useTelecallerIDUpdation();
  const { isLoading: unmapping, unmapTelecallerUserID } =
    useUnmapTelecallerUserID();

  const handleUpdationModalShow = (refNo) => {
    setDataToUpdate((prevState) => {
      return {
        ...prevState,
        refNo,
      };
    });
    setShowUpdationModal(true);
  };

  const handleUpdationModalClose = () => {
    setShowUpdationModal(false);
  };

  const handleUnMapModalShow = (refNo) => {
    setDataToUpdate((prevState) => {
      return {
        ...prevState,
        refNo,
      };
    });
    setShowUnMapModal(true);
  };

  const handleUpdationConfirmationModalShow = () => {
    setShowUpdationConfirmationModal(true);
  };

  const handleUpdationConfirmationModalClose = () => {
    setDataToUpdate({
      refNo: "",
      userId: "",
    });
    setShowUpdationConfirmationModal(false);
  };

  const handleUnMapModalClose = () => {
    setDataToUpdate({
      refNo: "",
      userId: "",
    });
    setShowUnMapModal(false);
  };

  const handleSubmit = (data) => {
    fetchClientDataByRefNumber(data);
  };

  const handleTelecallerIDUpdate = (data) => {
    handleUpdationModalClose();
    handleUpdationConfirmationModalShow();
    setDataToUpdate((prevState) => {
      return {
        ...prevState,
        ...data,
      };
    });
  };

  const handleUpdate = async () => {
    const result = await updateTelecallerID(dataToUpdate);
    if (result.success && result.data) {
      fetchClientDataByRefNumber({ refNo: dataToUpdate.refNo });
      handleUpdationConfirmationModalClose();
      toast.success(result.data.data || "Updated Successfully");
    } else if (!result.success && result.data) {
      toast.error(result.data.data);
    }
  };

  const handleUnmap = async () => {
    const result = await unmapTelecallerUserID({ refNo: dataToUpdate.refNo });
    if (result.success) {
      fetchClientDataByRefNumber({ refNo: dataToUpdate.refNo });
      handleUnMapModalClose();
      toast.success(result.data.data || "Unmapped Successfully");
    } else if (!result.success && result.data) {
      toast.error(result.data.data);
    }
  };

  return (
    <>
      <div>
        <Header portal="TELECALLER" />
        <SingleSignOnSideBar />

        <main className="idu-main-content">
          <div className="idu-card">
            <h2>ID Updation</h2>

            <SearchForm
              onSearch={handleSubmit}
              isLoading={searchResultsLoading}
            />

            {error && <p className="idu-error-text">{error.message}</p>}
            {data && !error && (
              <ClientInfoTable
                clientInfo={data}
                onUpdateClick={handleUpdationModalShow}
                onUnMapClick={handleUnMapModalShow}
              />
            )}
          </div>
        </main>
      </div>

      {showUpdationModal && (
        <UpdationModal
          show={showUpdationModal}
          onClose={handleUpdationModalClose}
          refNo={dataToUpdate.refNo}
          onTelecalledIDUpdate={handleTelecallerIDUpdate}
        />
      )}

      <UpdationConfirmationModal
        show={showUpdationConfirmationModal}
        onClose={handleUpdationConfirmationModalClose}
        onUpdate={handleUpdate}
        isLoading={updating}
      />

      <UnMapModal
        show={showUnMApModal}
        onClose={handleUnMapModalClose}
        isLoading={unmapping}
        onUnmap={handleUnmap}
      />
    </>
  );
};

export default TelecallerIDUpdation;
